import { ReactElement, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { TermsAndConditionsFieldConfig } from "@evergiving/common/dist/es2015/form";
import ReactMarkdown from "react-markdown";

import { LabelledField } from "@/lib/components/LabelledField";
import { LabelText } from "@/lib/components/LabelText";
import { Checkbox } from "@/lib/components/Checkbox";
import { RootState } from "@/lib/redux/types";
import { FieldError } from "@/lib/components/FieldError";

export function TermsAndConditionsComponent({
  termsAndConditionsFieldConfig,
}: {
  termsAndConditionsFieldConfig: TermsAndConditionsFieldConfig;
}): ReactElement {
  const validate = useCallback((value: boolean) => !value, []);
  const name = "termsAndConditionsConsent";
  const anyErrors = useSelector((state: RootState) => state.errors[name]);
  const [isDirty, setIsDirty] = useState(false);

  const markAsDirty = useCallback(() => {
    setIsDirty(true);
  }, []);

  return (
    <div>
      <div className="label">{termsAndConditionsFieldConfig.labelText}</div>
      <ReactMarkdown className="termsAndConditionsBody" linkTarget="_blank">
        {termsAndConditionsFieldConfig.bodyMarkdownText}
      </ReactMarkdown>
      <LabelledField id="termAndConditions">
        <div className="label">*&nbsp;</div>
        <Checkbox name={name} validate={validate} markAsDirty={markAsDirty} />
        <LabelText>{termsAndConditionsFieldConfig.acceptanceText}</LabelText>
        <div role="alert">
          {anyErrors && isDirty ? (
            <FieldError
              id={`${name}-errors`}
              messages={[termsAndConditionsFieldConfig.notAcceptedErrorText]}
            />
          ) : null}
        </div>
      </LabelledField>
    </div>
  );
}
